<template>
  <div class="show-box">
    <div style="color:#999" v-if="data[widget.startPropName] === undefined">未填写</div>
    <div v-else>{{ fmt(data[widget.startPropName]) }}</div>
    <span style="padding: 0  8px">-</span>
    <div style="color:#999" v-if="data[widget.endPropName] === undefined">未填写</div>
    <div v-else>{{ fmt(data[widget.endPropName])  }}</div>
  </div>
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import dayjs from 'dayjs';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {DateRangeFieldType} from "@/components/business/crud/interface/FieldType";
import _ from "lodash";

const props = defineProps<{
  propName: string;
  widget: DateRangeFieldType;
  info: WidgetInfo;
  data: any;
}>();

function fmt(date: unknown) {
  if (date !== undefined) {
    return dayjs(_.toNumber(date)).format(
        props.widget.format || "YYYY-MM-DD"
    );
  } else {
    return '';
  }
}


</script>

<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: $font-size-small;
}
</style>
